export default "__VITE_ASSET__VznzTyCZ__"